import axios from "axios";
import { api } from "./Api";

export interface WmeaProfile {
  age: number;
  height: number;
  weight: number;
  gender: "male" | "female";
  smoking: "0" | "1";
  bloodpressuremedication: "0" | "1";
  diabetes: "0" | "type1" | "type2";
}

export interface WmeaSession {
  resultSource?: "api" | "sdk_pilot";
  sessionId: string;
  token: string;
  refreshToken: string;
  studyId: string;
  apiHost: string;
  expiresAt: string;
}

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export async function getWmeaConfig() {
  const response = await api.get<{ data: { enabled: boolean; ready: boolean; message?: string } }>(
    "/deepaffex/wmea/config", { headers: headers() }
  );
  return response.data.data;
}

export async function startWmea(input: { requestId: string; healthPlace: string; customerServiceId: string; profile: WmeaProfile }) {
  const response = await api.post<{ data: WmeaSession }>("/deepaffex/wmea/session", input, { headers: headers(), timeout: 40000 });
  return response.data.data;
}

export interface SdkResults {
  MeasurementID: string;
  StatusID?: string;
  Multiplier: number;
  Channels: Record<string, { Data: number[]; Notes?: string[] }>;
}

export async function saveWmea(sessionId: string, measurementId: string, sdkResults?: SdkResults) {
  const response = await api.post<{ data: { id: string } }>("/deepaffex/wmea/results", { sessionId, measurementId, ...(sdkResults ? { sdkResults } : {}) }, { headers: headers(), timeout: 40000 });
  return response.data.data;
}

export async function cancelWmea(sessionId: string) {
  try {
    await api.delete(`/deepaffex/wmea/session/${encodeURIComponent(sessionId)}`, { headers: headers(), timeout: 40000 });
  } catch (error) {
    // A failed start may never have created a session.
    if (!axios.isAxiosError(error) || error.response?.status !== 404) throw error;
  }
}

export function wmeaError(error: unknown): string {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 404 && error.config?.url === "/deepaffex/wmea/config") return "A Medição 2.0 não está disponível nesta versão da API. Atualize a API e tente novamente.";
    if (error.response?.status === 401) return "Sua sessão expirou. Entre novamente para continuar.";
    return error.response?.data?.message || "Não foi possível conectar à API. Verifique a conexão e tente novamente.";
  }
  return "Não foi possível carregar a medição. Confira a permissão da câmera e tente novamente.";
}
